<template>

    <div
        v-if="Object.values(changes).length > 0"
        class="alert alert-info"
    >
        <h3>{{ lang('all.winkelwagen_is_aangepast') }}</h3>
        <p>{{ lang('all.de_onderstaande_producten_in_de_winkelwagen_zijn_a') }}</p>
        <ul>
            <li
                v-for="(newquantity, productsku) in changes"
            >
                {{ lang('all.voor_product') }} <strong>{{ productsku }}</strong> {{ lang('all.is_het') }} <code>{{ lang('all.aantal2') }}</code> {{ lang('all.aangepast_naar') }} <strong>{{ newquantity }}</strong>
            </li>
        </ul>
        <p class="mb-0">{{ lang('all.indien_het_nieuwe') }} <code>{{ lang('all.aantal2') }}</code> {{ lang('all.voor_een_product_op') }} <strong>0</strong> {{ lang('all.is_gezet_is_het_product_uit_de_winkelwagen_verwijd') }}</p>
    </div>

</template>

<script>

export default {

    name:'CartChanges',

    props: {
        changes:{
            type:Object,
            default:() => {},
        },
    },

}

</script>
